import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import { homeHeroKeys } from "../../shared/keys";
import type { Hero } from "../../shared/types";

export function useHero(initialHero?: Hero[]) {
  const locale = useLocale();

  return useQuery<Hero[]>({
    queryKey: homeHeroKeys.hero(locale),
    queryFn: () => fetcher<Hero[]>(`/${locale}/api/home/hero?locale=${locale}`),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...(initialHero !== undefined ? { initialData: initialHero } : {}),
  });
}
